import React from 'react'
import '../Home/Home.scss'
import {BrowserRouter as Router, withRouter } from 'react-router-dom'
import Routers from '../../rutas/Routers'
import {Grid} from 'semantic-ui-react'
import { useAuth } from '../../context/authContext'
import Routers2 from '../../rutas/Routers2'


export default function Home2() {



    
    
    

    return (


            <Router  >  
                <Grid className="layout-home"  >
                    <Grid.Row >
                        <Grid.Column width={16} >
                            <Routers2    />
                            
                        </Grid.Column>
 
                    </Grid.Row>

                </Grid>

            </Router>


   
    )
}

